import React from "react";
import { ProductBadge } from "packages/ui-shared/components/ProductBadge";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "badge" | "image">;
};

export const ProductCardBadge: React.FC<Props> = ({ product }) => {
  if (!product.badge) return null;
  if (!product.image.src) return null;
  return <ProductBadge src={product.badge.src} alt={product.badge.alt} />;
};
